$.fn.setCursorPosition = function(pos) {
    if ($(this).get(0).setSelectionRange) {
        $(this).get(0).setSelectionRange(pos, pos);
    } else if ($(this).get(0).createTextRange) {
        var range = $(this).get(0).createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
};
if ($(".masked-phone")[0]) {
    $(".masked-phone").click(function () {
        $(this).setCursorPosition(4);
    }).mask("+38(999) 999-9999", {autoclear: false});
}